export default __webpack_public_path__ + "static/media/figma.04a1dba5.png";